import { render, staticRenderFns } from "./EditPostModal.vue?vue&type=template&id=c936708e&scoped=true"
import script from "./EditPostModal.vue?vue&type=script&lang=js"
export * from "./EditPostModal.vue?vue&type=script&lang=js"
import style0 from "./EditPostModal.vue?vue&type=style&index=0&id=c936708e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c936708e",
  null
  
)

export default component.exports